// Mock data for DÉCORATION DE SOUSA FRÈRES landing page
// Entreprise de second œuvre et agrandissements

export const companyInfo = {
  name: "DÉCORATION DE SOUSA FRÈRES",
  tagline: "Déjà 60 ans que nous bâtissons notre relation, nous consolidons votre confiance",
  foundedYear: 1965,
  heroImage: "https://customer-assets.emergentagent.com/job_finition-sousa/artifacts/s7axzr25_0A6E20AF-9E26-4502-B9CA-202AAFA696DA.jpg",
  description: "Décoration / Rénovation / Construction - Des moyens humains, matériels et logistiques au service de votre projet.",
  address: "6 rue du Pré de l'Hôpital, 94190 Villeneuve-Saint-Georges"
};

export const biography = {
  title: "Notre Histoire",
  subtitle: "De pères en fils, Le Groupe De Sousa écrit son histoire et un petit bout de la vôtre.",
  paragraphs: [
    "À l'initiative d'une fraternité solide, le Groupe De Sousa, fondé en 1965, est la mise en forme d'un travail de fond d'hommes de l'art expérimentés. Ces professionnels du bâtiment ont eu loisir de collaborer avec les grands noms du secteur d'activité depuis 60 années maintenant.",
    "Aujourd'hui, toujours acteurs et de renommée éprouvée, Le Groupe De Sousa aspire à satisfaire toujours plus sa clientèle et à parfaire son savoir-faire.",
    "Chaque appartement ou maison, collectif ou individuel, fait l'objet d'un soin attentif et est pris en charge avec un soin particulier. Les importantes capacités de stockage du Groupe permettent une large palette de choix de revêtements et les matériaux employés de qualité combinés à l'efficacité et la rapidité d'actions des employés, garantissent une prestation artisanale haut de gamme."
  ],
  values: [
    { title: "Savoir-faire", description: "Le Groupe De Sousa cherche à parfaire encore un peu plus son niveau de prestation à chaque nouveau chantier." },
    { title: "Qualité", description: "Des matériaux de qualité pour une prestation artisanale haut de gamme." },
    { title: "Expertise", description: "60 ans d'expérience au service de votre projet." },
    { title: "Partenariat", description: "Des relations durables avec les promoteurs nationaux." }
  ]
};

export const keyFigures = [
  { value: "200", label: "Collaborateurs actifs" }
];

export const specialties = [
  {
    id: "carrelage",
    title: "Carrelage",
    description: "Pose de carrelage pour sols et murs avec finitions impeccables.",
    image: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?w=800&q=80"
  },
  {
    id: "sols-souples",
    title: "Sols souples",
    description: "Installation de revêtements souples : vinyle, linoléum, moquette.",
    image: "https://images.unsplash.com/photo-1581858726788-75bc0f6a952d?w=800&q=80"
  },
  {
    id: "parquet",
    title: "Parquet",
    description: "Pose et rénovation de parquet massif, contrecollé et stratifié.",
    image: "https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=800&q=80"
  },
  {
    id: "peinture",
    title: "Peinture",
    description: "Travaux de peinture intérieure et extérieure, finitions soignées.",
    image: "https://images.unsplash.com/photo-1562259949-e8e7689d7828?w=800&q=80"
  },
  {
    id: "renovation",
    title: "Rénovation",
    description: "Rénovation complète d'appartements et maisons.",
    image: "https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=800&q=80"
  },
  {
    id: "agrandissement",
    title: "Agrandissement",
    description: "Extensions et agrandissements de votre espace de vie.",
    image: "https://images.unsplash.com/photo-1504307651254-35680f356dfd?w=800&q=80"
  }
];

export const renovationInfo = {
  title: "Devenus spécialistes de la rénovation",
  description: "Fort d'une main-d'œuvre hautement qualifiée et fidèle aux techniques traditionnelles du bâtiment, chaque corps de métier s'attache à rétablir l'équilibre des volumes, l'harmonie et la noblesse des façades tout en respectant le savoir-faire des anciens. Un avant-après qui conserve la véritable identité de chaque ouvrage rénové."
};

export const reasons = [
  {
    id: 1,
    title: "60 ans d'expérience",
    description: "Un savoir-faire transmis de pères en fils depuis 1965."
  },
  {
    id: 2,
    title: "200 Collaborateurs",
    description: "Une équipe d'hommes de l'art expérimentés et qualifiés."
  },
  {
    id: 3,
    title: "Partenaires de confiance",
    description: "Collaboration avec les grands noms du secteur depuis 60 ans."
  },
  {
    id: 4,
    title: "Qualité artisanale",
    description: "Des matériaux de qualité pour une prestation haut de gamme."
  },
  {
    id: 5,
    title: "Capacité de stockage",
    description: "Une large palette de choix de revêtements disponibles."
  },
  {
    id: 6,
    title: "Efficacité",
    description: "Rapidité d'action et respect des délais garantis."
  }
];

export const partners = [
  {
    id: 1,
    name: "Bouygues Immobilier",
    logo: "https://www.bouygues-immobilier.com/themes/custom/bouyguesimmo/logo.svg"
  },
  {
    id: 2,
    name: "Nexity",
    logo: "https://www.nexity.fr/sites/all/themes/nexity_v2/images/logo-nexity.svg"
  },
  {
    id: 3,
    name: "Marignan",
    logo: "https://www.marignan-immobilier.com/themes/marignan/logo.svg"
  },
  {
    id: 4,
    name: "Groupe Pichet",
    logo: "https://www.pichet.fr/themes/custom/pichet/logo.svg"
  },
  {
    id: 5,
    name: "Les Nouveaux Constructeurs",
    logo: "https://www.lesnouveauxconstructeurs.fr/themes/starter/logo.svg"
  },
  {
    id: 6,
    name: "Groupe Arc",
    logo: "https://www.groupearc.fr/themes/starter/logo.svg"
  },
  {
    id: 7,
    name: "Groupe Arcade",
    logo: "https://www.arcade-vivre.fr/themes/starter/logo.svg"
  },
  {
    id: 8,
    name: "BPD",
    logo: "https://www.bfranceinvestimentos.com.br/themes/starter/logo.svg"
  },
  {
    id: 9,
    name: "Spirit",
    logo: "https://www.spirit-immobilier.fr/themes/starter/logo.svg"
  },
  {
    id: 10,
    name: "France Pierre",
    logo: "https://www.pierreetvacances-immobilier.com/themes/starter/logo.svg"
  }
];

export const contactInfo = {
  title: "Nous trouver",
  subtitle: "Notre siège social",
  phone: "+33 1 XX XX XX XX",
  email: "contact@desousa-freres.fr",
  address: "6 rue du Pré de l'Hôpital, 94190 Villeneuve-Saint-Georges"
};
